/* eslint-disable complexity */
import { useEffect } from "react";
import { trackPageEvent } from "../../utilities/trackPageEvent";
import styles from "../../styles";
import Faqs from "../../components/faqs";
import TierInfo from "../../components/tier-info";
import Connect from "../../components/connect";
import WorldOfStyle from "../../components/world-of-style";
import Benefits from "../../components/benefits";
import LevelUp from "../../components/level-up";
import SuccessOverlay from "../../components/success-overlay";
import LoyaltyJoinError from "../../components/LoyaltyJoinError";
import { useJoinStatus } from "../../context/join-status";
import PropTypes from "prop-types";
import classNames from "classnames";
import { errorMessageKeys } from "../../helpers/getErrorMessage";

const analyticsProps = {
  pageName: "invited landing page",
};

export default function TargetedView({ assetsUrl, isAnonymous }) {
  const [state] = useJoinStatus();

  const { showSuccess, errorCode, currentTierId, loyaltyData } = state;
  analyticsProps.consentStatus = currentTierId ? "OptedIn" : "OptedOut";

  const currentTierIndex = loyaltyData.tiers?.findIndex((tier) => {
    return tier.id === currentTierId;
  });

  if (loyaltyData && loyaltyData.tiers && currentTierId) {
    analyticsProps.currentTier =
      loyaltyData.tiers[currentTierIndex].name.toLowerCase() +
      " " +
      Number(currentTierIndex + 1);
  }

  useEffect(() => {
    trackPageEvent(analyticsProps);
  }, []);

  if (showSuccess) {
    const footer = document.querySelector("#chrome-footer footer");
    if (footer) {
      footer.style.position = "fixed";
    }
  }
  return (
    <div className={classNames(styles.loyaltyFaqPage)} id="loyaltyFaqPage">
      <div
        className={classNames(styles.container, {
          [styles.fixBackground]: showSuccess,
        })}
      >
        <Connect
          currentTierId={currentTierId}
          assetsUrl={assetsUrl}
          isAnonymous={isAnonymous}
        />
        <div
          className={styles.benefitsLevelUpContainer}
          id="benefitsLevelUpContainer"
        >
          <Benefits assetsUrl={assetsUrl} />
          <LevelUp assetsUrl={assetsUrl} />
        </div>
        {Object.keys(loyaltyData).length !== 0 && (
          <TierInfo loyaltyData={loyaltyData} assetsUrl={assetsUrl} />
        )}
        <WorldOfStyle
          currentTierId={currentTierId}
          assetsUrl={assetsUrl}
          isAnonymous={isAnonymous}
        />
      </div>
      <Faqs />
      {showSuccess && (
        <SuccessOverlay
          loyaltyData={loyaltyData}
          currentTierId={currentTierId}
        />
      )}
      {errorCode && (
        <LoyaltyJoinError
          message={
            errorMessageKeys[errorCode]
              ? errorMessageKeys[errorCode]
              : errorMessageKeys.optInError
          }
        />
      )}
    </div>
  );
}

TargetedView.propTypes = {
  assetsUrl: PropTypes.string,
  isAnonymous: PropTypes.bool.isRequired,
};
